const isProduction = process.env.NODE_ENV === 'production';

// Railway backend URL — used in both dev and prod
// Override with REACT_APP_API_URL env var in Railway frontend service settings
const RAILWAY_BACKEND = "https://pulsenote-backend-production.up.railway.app";

export const config = {
    // AI backend — our Railway proxy → RunPod → Llama 3.2 Vision
    AI_API_URL: process.env.REACT_APP_API_URL
        ? `${process.env.REACT_APP_API_URL}/api/query`
        : `${RAILWAY_BACKEND}/api/query`,

    AI_BASE_URL: process.env.REACT_APP_API_URL || RAILWAY_BACKEND,

    // Legacy (unused — kept for reference)
    OLLAMA_URL: "http://localhost:11434/api/chat",
    GROQ_URL: "https://api.groq.com/openai/v1/chat/completions",
    GROQ_API_KEY: process.env.REACT_APP_GROQ_API_KEY
};
